<template>
  <div>
    <div class="accordion py-4" @click="isExpanded = !isExpanded">
      {{ guide_item.item }}
    </div>
    <div :class="{ 'bg-white text-black px-10 py-2': isExpanded }">
      <!-- {{guide_item.buyers_guide_menu_id}} -->
      <div
        class="text-left"
        @click="onClick(guide_item.buyers_guide_menu_id)"
        v-if="isExpanded"
      >
      <!-- <pre>
        {{children}}
      </pre> -->
        <div v-for="(item, i) in children" :key="i">
          <div v-if="item.type === 'buyers_guide_content'" 
            v-html="item.buyers_guide_content" 
            @click="clicked"
          ></div>
          <div 
            v-else-if="item.type === 'buyers_guide_menu'"
            @click="onBuyersGuideMenuItemClick(item)"
            class="hover:border hover:border-gray-500"
          >
            <!-- {{ item.item }} -->  
            <accordion-child 
              :guide_item="item"
            />
          </div>
        </div>
        <!-- <accordion-child
          class="bg-gray-200 pl-4 border-b border-gray-500 text-black"
          v-for="(item, i) in children"
          :key="i"
          :guide_item="item"
        >
        {{ item}}
        </accordion-child> -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
export default {
  name: "accordion-child",
  data() {
    return {
      isExpanded: false,
      title: "",
      children: [],
    };
  },
  props: ["guide_item"],
  watch: {
    guide_item: {
      handler(e) {
        this.getChildren(e.buyers_guide_menu_id);
      },
      immediate: true,
    },
  },

  methods: {
   
    getChildren(id) {
      let data = {
        parent_id: id,
      };
      axios.post("/buyers_guide/get_content", data).then((res) => {
        this.children = res.data;
      });
    },
  },
};
</script>

